import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M127.184 82.413a22.72 22.72 0 0 0-16.073-6.655 22.7 22.7 0 0 0-16.054 6.655L6.659 170.811c-8.879 8.854-8.879 23.248 0 32.126 8.879 8.879 23.272 8.879 32.151 0l49.574-49.574v172.39c0 54.381 44.103 98.483 98.483 98.483h37.878c12.57 0 22.727-10.182 22.727-22.727s-10.157-22.727-22.727-22.727h-37.878c-29.284 0-53.029-23.745-53.029-53.029v-172.39l49.593 49.574c8.879 8.879 23.272 8.879 32.126 0 8.879-8.878 8.879-23.272 0-32.126zm245.637 335.174a22.72 22.72 0 0 0 16.072 6.655 22.73 22.73 0 0 0 16.054-6.655l88.398-88.398c8.873-8.854 8.873-23.248 0-32.126-8.878-8.879-23.272-8.879-32.15 0l-49.575 49.574v-172.39c0-54.381-44.102-98.483-98.483-98.483h-37.878c-12.545 0-22.727 10.182-22.727 22.727s10.182 22.727 22.727 22.727h37.878c29.284 0 53.029 23.745 53.029 53.029v172.39l-49.592-49.574c-8.879-8.879-23.273-8.879-32.127 0-8.879 8.878-8.879 23.272 0 32.126z"
    }, null, -1)
  ])))
}
export default { render: render }